import { noop } from 'lodash';

export const updateMParticleConsentState = noop;
